export const listOfTerm = {
    "Onetime paid upfront": (price) => ({
      value: `Onetime paid upfront (${price})`,
      prices: price,
      payment: 'oneTime'
    }),
    'Month-to-Month': (price) => ({
      value: `Month-to-Month (${price})`,
      prices: price,
      payment: 'monthly'
    }),
    '1 Year Term / Monthly Payment': (price) => ({
      value: `1 Year Term / Monthly Payment (${price})`,
      prices: price,
      payment: 'monthly'
    }),
    '1 Year Term / Onetime paid upfront': (price) => ( {
      value: `1 Year Term / Onetime paid upfront (${price})`,
      prices: price,
      payment: 'oneTime'
    }),
    '3 Year Term / Monthly Payment': (price) => ( {
      value: `3 Year Term / Monthly Payment (${price})`,
      prices: price,
      payment: 'monthly'
    }),
    '3 Year Term / Anually Payment': (price) => ( {
      value: `3 Year Term / Anually Payment (${price})`,
      prices: price,
      payment: 'monthly'
    }),
    '3 Year Term / Onetime paid upfront': (price) => ( {
      value: `3 Year Term / Onetime paid upfront (${price})`,
      prices: price,
      payment: 'oneTime'
    }),
  };